import { MA_OPPORTUNITIES_FILTERS_SUMMARY_QUERY } from '../operations';
import { useQuery } from '@apollo/client';

export const useGetFiltersSummary = () => {
  const { data, previousData, loading, error } = useQuery(MA_OPPORTUNITIES_FILTERS_SUMMARY_QUERY, {
    fetchPolicy: 'cache-and-network',
  });

  const maOpportunitiesSummary = loading
    ? previousData?.maOpportunitiesSummary
    : data?.maOpportunitiesSummary;

  return {
    data: maOpportunitiesSummary || {},
    loading,
    error,
  };
};
